<template>
  <div class="toggle-tab" v-if="shouldShowToggle" style="padding: 12px 5px;">
    <div class="view-toggle-wrapper">
      <span :class="{ active: !CardView }">{{ FlyerView }}</span>
      <label class="toggle-switch">
        <input type="checkbox" :checked="TiledView" @change="onToggle" />
        <span class="slider"></span>
      </label>
      <span :class="{ active: TiledView }">{{ GridView }}</span>
    </div>
    
  </div>
</template>


<script>
import featureMixin from "@/mixins/featureMixin";
import { mapGetters, mapActions } from 'vuex';

export default {
  name: "TiledViewToggleButton",
  mixins: [featureMixin],
  props: {
 
},
  computed: {
		...mapGetters(['TiledView']),
		...mapGetters('config', ['features']),
		shouldShowToggle() {
        return this.features?.filters?.find(x => x.name === 'tiledview')?.enabled === true;
      },
      FlyerView() {
       
      return this.features?.filters?.find(x => x.name === 'tiledview')?.labels.off || 'Grid';
      },
      GridView() {
        
        return this.features?.filters?.find(x => x.name === 'tiledview')?.labels.on || 'Tiled View';
      },
    
	
    
  },
   methods: {
    ...mapActions(['toggleTiledView']),
    onToggle() {
      this.toggleTiledView(); 
    }
  }
};
</script>

<style scoped>
.view-toggle-wrapper {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 9999px; 
  background-color: white;
  gap: 6px;
  padding: 6px 14px;
  font-size: 11px;
  border: 1px solid #ccc; 
  box-shadow: 0 1px 3px rgba(0,0,0,0.1); 
}

.toggle-switch {
  position: relative;
  width: 28px;
  height: 16px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0; left: 0;
  right: 0; bottom: 0;
  background-color: #ccc;
  border-radius: 16px;
  transition: 0.3s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 10px; width: 10px;
  left: 3px; bottom: 3px;
  background-color: white;
  border-radius: 50%;
  transition: 0.3s;
}

input:checked + .slider {
  background-color: #28a745; /* green */
}

input:checked + .slider:before {
  transform: translateX(12px);
  box-shadow: 0 0 2px #28a745;
}

.view-toggle-wrapper .active {
  font-weight: bold;
  
}
</style>

